import api from '../api.js';

/**
 * Fetch the list of experts. Optionally filter by sector.
 */
export const fetchExpertsList = async ({ sector, search } = {}) => {
  const params = {};
  if (sector && sector !== 'All') params.sector = sector;
  if (search) params.search = search;

  const { data } = await api.get(`/experts`, { params });
  return data;
};

/**
 * Fetch a single expert profile by its MongoDB _id.
 */
export const fetchExpertById = async (id) => {
  const { data } = await api.get(`/experts/${id}`);
  return data;
};

/**
 * Admin/Editor: submit a new expert profile.
 */
export const createExpert = async (payload) => {
  const { data } = await api.post(`/experts`, payload);
  return data;
};

/**
 * Admin/Editor: edit expert profile fields (name, education, sector, photoUrl, etc).
 */
export const updateExpert = async (id, payload) => {
  const { data } = await api.put(`/experts/${id}`, payload);
  return data;
};

/**
 * Admin only: delete an expert profile permanently.
 */
export const deleteExpert = async (id) => {
  const { data } = await api.delete(`/experts/${id}`);
  return data;
};